import { render, staticRenderFns } from "./DetailFleetHistory.vue?vue&type=template&id=8ad2f6ac&"
import script from "./DetailFleetHistory.vue?vue&type=script&lang=js&"
export * from "./DetailFleetHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports